export enum API {
    ADDRESOURCE = "addResource",
    GETMETADATA = "getMetaData"
    
}